module.exports = __webpack_public_path__ + "static/img/success1.6bc69352.png";